import type { State } from '../../Slice/index.js'
import type { ISpinMetaEntry, SpinMetaQuery } from '../../Slice/Spin/SpinMetaSlice.ts'
import { spinMetaKey } from '../../Slice/Spin/SpinMetaSlice.ts'

const IDLE: Omit<ISpinMetaEntry, 'scopeId'> = { status: 'idle' }

/** The cached answer to a SPIN metadata query; `idle` when it was never requested or there is no query. */
export const selectSpinMeta =
  (query: SpinMetaQuery | null) =>
  (state: typeof State): Omit<ISpinMetaEntry, 'scopeId'> =>
    (query && state.spinMeta.entries[spinMetaKey(query)]) || IDLE
